import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useRegister = (): ReturnType<typeof useApiMutation> =>
  useApiMutation(RESOURCES.REGISTER, CLIENT_METHODS.POST)
